import { render } from "./TaskTypeShow.vue?vue&type=template&id=03589104&scoped=true"
import script from "./TaskTypeShow.vue?vue&type=script&lang=js"
export * from "./TaskTypeShow.vue?vue&type=script&lang=js"

import "./TaskTypeShow.vue?vue&type=style&index=0&id=03589104&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03589104"]])

export default __exports__